/* Taux BCE (frankfurter.dev) — généré par promo-cart/fx_update.py, cron quotidien. Ne pas éditer à la main. */
window.AP_FX={"base":"EUR","date":"2026-11-02","rates":{"AUD":1.6004,"CAD":1.5673,"CHF":0.9193,"GBP":0.8358,"NZD":1.9934,"USD":1.1216}};
